import { ssFormUtils, ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';
import { generateLabelWithPopover } from '@bit/ui-common.ui-components/ss-utils/utils/formUtils';

const
{ INPUT, DATE_PICKER, SELECT, CHECK } = ssFormUtils,
{ validationRules } = ssFormValidationUtils,
{
    isRequired,
    isPhone,
    isEmail,
    isMinLength,
    isMaxLength,
    isNumeric,
    isAlphanumeric,
    isAlphanumericWithSpaces,
    isAlphaWithSpacesAndSpecial,
    isLowercaseAlphanumeric,
    isStreetAddress,
    isGov
} = validationRules;

export const dodPersonalInformationConfig = {
    key: 'dodPersonalInformation',
    step: 1,
    formItems: {
        firstName: {
            label: 'First Name',
            type: INPUT,
            rules: [ isRequired, isAlphaWithSpacesAndSpecial(',-.\'`') ]
        },
        middleName: {
            label: 'Middle Name',
            type: INPUT,
            rules: [ isAlphaWithSpacesAndSpecial(',-.\'`') ],
            optional: true
        },
        lastName: {
            label: 'Last Name/Surname',
            type: INPUT,
            rules: [ isRequired, isAlphaWithSpacesAndSpecial(',-.\'`') ]
        }
    }
};

export const dodOfficeAddressConfig = {
    key: 'dodOfficeAddress',
    step: 2,
    formItems: {
        streetAddress: {
            label: 'Street Address',
            type: INPUT,
            rules: [ isRequired, isStreetAddress ]
        },
        city: {
            label: 'City',
            type: INPUT,
            rules: [ isRequired, isAlphanumericWithSpaces ]
        },
        zipPostal: {
            label: 'Zip/Postal',
            type: INPUT,
            rules: [ isRequired, isNumeric, isMinLength(5) ]
        },
        stateProvince: {
            label: 'State Province',
            type: SELECT,
            rules: [ isRequired ]
        },
        embassy: {
            label: 'US Diplomatic Mission Consulate or Embassy',
            type: SELECT,
            rules: [ isRequired ]
        },
        country: {
            label: 'Country',
            type: SELECT,
            rules: [ isRequired ]
        },
        phoneNumber: {
            label: 'Phone Number',
            type: INPUT,
            rules: [ isPhone, isMinLength(5), isMaxLength(25) ]
        }
    }
};

export const dodCredentialsConfig = {
    key: 'dodCredentials',
    step: 3,
    formItems: {
        userId: {
            label: generateLabelWithPopover('User ID', 'Please create your User ID using only lowercase letters and/or numbers. Your User ID must be between 3 and 30 characters in length.'),
            type: INPUT,
            rules: [ isRequired, isLowercaseAlphanumeric, isMinLength(3), isMaxLength(30) ]
        },
        emailAddress: {
            label: 'Email Address',
            type: INPUT,
            rules: [ isRequired, isEmail, isGov ]
        },
        verifyEmailAddress: {
            label: 'Verify Email Address',
            type: INPUT,
            rules: [ isRequired ]
        }
    }
}

export const dodSecurityConfig = {
    key: 'dodSecurity',
    step: 4,
    formItems: {
        born: {
            label: 'In what city were you born?',
            type: INPUT,
            rules: [ isRequired, isAlphanumericWithSpaces ]
        },
        food: {
            label: 'What is your favorite food?',
            type: INPUT,
            rules: [ isRequired, isAlphanumericWithSpaces ]
        },
        color: {
            label: 'What is your favorite color?',
            type: INPUT,
            rules: [ isRequired, isAlphanumericWithSpaces ]
        }
    }
}

export const dodAuthConfig = {
    key: 'dodAuth',
    step: 5,
    formItems: {
        signature: {
            label: 'Enter your full name to digitally sign',
            type: INPUT,
            rules: [ isRequired, isAlphaWithSpacesAndSpecial(',-.\'`') ]
        },
        agree: {
            label: 'I understand and agree to the above',
            type: CHECK,
            rules: [ isRequired ]
        }
        // Not implemented. Ignored for now.
        // upload: {
        //     label: 'Designee Letter',
        //     type: INPUT,
        //     rules: [ isRequired ]
        // }
    }
}
